export default "__VITE_ASSET__DwNYX5qy__"